
    import './styles.scoped.css';
    export default {
  "dialog": "awsui_dialog_1d2i7_dux47_106",
  "modal-slide-up": "awsui_modal-slide-up_1d2i7_dux47_1",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1d2i7_dux47_1",
  "refresh": "awsui_refresh_1d2i7_dux47_129",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_1d2i7_dux47_1",
  "root": "awsui_root_1d2i7_dux47_162",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_1d2i7_dux47_1",
  "hidden": "awsui_hidden_1d2i7_dux47_225",
  "focus-lock": "awsui_focus-lock_1d2i7_dux47_229",
  "small": "awsui_small_1d2i7_dux47_247",
  "medium": "awsui_medium_1d2i7_dux47_250",
  "large": "awsui_large_1d2i7_dux47_253",
  "max": "awsui_max_1d2i7_dux47_256",
  "breakpoint-xs": "awsui_breakpoint-xs_1d2i7_dux47_256",
  "container": "awsui_container_1d2i7_dux47_261",
  "content": "awsui_content_1d2i7_dux47_285",
  "no-paddings": "awsui_no-paddings_1d2i7_dux47_288",
  "header": "awsui_header_1d2i7_dux47_292",
  "header--text": "awsui_header--text_1d2i7_dux47_299",
  "footer": "awsui_footer_1d2i7_dux47_303",
  "dismiss-control": "awsui_dismiss-control_1d2i7_dux47_313",
  "modal-open": "awsui_modal-open_1d2i7_dux47_317"
};
  